/* Mama Jewels: price summary above Add to cart for products without the chain/bracelet picker (rings).
   As soon as a paid option of the options app (Globo) is chosen, a small overview appears:
   "Ring 14 Karat 869 € / Gravur +40 € / Blattgold +25 € / Gesamt 934 €". The Add to cart button always shows the
   total ("In den Warenkorb · 869 €"). DE: karaat = native variantoptie "Karat" ("14 Karat"), bedragen in de-DE-notatie. Globo's own "Selections will add ..." line is hidden while the overview shows.
   The displayed product price already includes Globo's extras; the ring itself = displayed price minus extras. */
(function () {
  if (window.mjPriceSummary) return;
  window.mjPriceSummary = true;

  // Works for "1.234,56 €", "489,00 €", "€489", "$1,234.56": the last separator followed by 1-2 digits is the decimal mark
  function cents(text) {
    var t = String(text || '').replace(/[^0-9.,]/g, '');
    if (!t) return null;
    var m = t.match(/^(.*)[.,](\d{1,2})$/);
    var n = m ? parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]) : parseFloat(t.replace(/[.,]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function money(c, cur, locale) {
    var opts = { style: 'currency', currency: cur || 'EUR' };
    if (c % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    try { return new Intl.NumberFormat(locale || 'de-DE', opts).format(c / 100); } catch (e) {
      try { return new Intl.NumberFormat('de-DE', opts).format(c / 100); } catch (e2) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    }
  }
  // Chosen paid Globo options (same rules as the chain picker); karat stays part of the product price
  function extras(form) {
    var out = [];
    // "(+15,00 €)", "(+ €15)", "(+$15.00)"
    var priceOf = function (t) { var m = String(t || '').match(/\(\s*\+\s*[^\d(]*([\d.,]+)[^\d()]*\)/); return m ? cents(m[1]) : 0; };
    var clean = function (t) { return String(t || '').replace(/\s+/g, ' ').replace(/\(.*$/, '').trim(); };
    form.querySelectorAll('.gpo-element').forEach(function (el) {
      if (!el.offsetParent) return;
      var labEl = el.querySelector('.gpo-label');
      var lab = labEl ? labEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (/karat|gehalt|legierung/i.test(lab)) return;
      var nameOf = function (opt) {
        if (/gravur|engrav/i.test(lab)) return 'Gravur';
        if (/glitzer|glitter|shimmer/i.test(lab)) return 'Glitzerpulver';
        if (/blattgold|gold flake/i.test(lab)) return 'Blattgold';
        if (/sondergr|(^|\s)ma(ß|ss)(\s|$|:|\*)|ringgr|gr(ö|oe)(ß|ss)e|ring\s*size/i.test(lab)) return opt && /nach ma(ß|ss)|speziell|sonder|custom/i.test(opt) ? 'Sondergröße' : (opt || 'Ringgröße');
        if (/einschluss|inclusion/i.test(lab) && opt) return opt;
        return clean(lab).replace(/^add\s+(an?\s+)?/i, '').replace(/\s*hinzuf(ü|ue)gen\s*\??$/i, '') || opt || 'Option';
      };
      el.querySelectorAll('select').forEach(function (s) {
        var o = s.options[s.selectedIndex];
        if (!o || !o.value) return;
        var c = priceOf(o.text);
        if (c) out.push({ name: nameOf(clean(o.text)), cents: c });
      });
      el.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (i) {
        var l = i.closest('label');
        var c = priceOf(l && l.textContent) || priceOf(lab);
        if (c) out.push({ name: nameOf(clean(l && l.textContent)), cents: c });
      });
    });
    return out;
  }

  function init() {
    var host = document.querySelector('[data-mj-ps]');
    var form = document.querySelector('product-form');
    if (!host || !form || document.querySelector('mj-gold-chain')) return;
    var info = form.closest('.product__info-container') || document.body;
    var priceEl = info.querySelector('[id^="price-"]');
    var cur = host.dataset.currency, locale = host.dataset.locale, label = host.dataset.label || 'Artikel';
    var box = document.createElement('div');
    box.className = 'mj-ps';
    box.hidden = true;
    var last = '';

    // Real price = price of the selected variant (from /products/<handle>.js) + Globo's own sum of the chosen
    // paid options ("Selections will add € X"). Independent of whether Globo already raised the shown price or not.
    var vp = null;
    (function () {
      try {
        var h = location.pathname.split('/products/')[1];
        if (!h) return;
        h = h.split(/[\/?#]/)[0];
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (d) {
          vp = {};
          d.variants.forEach(function (v) { vp[v.id] = v.price; });
          schedule();
        }).catch(function () {});
      } catch (e) {}
    })();
    function realPrice() {
      var s = shownPrice();
      if (!vp) return s;
      var idEl = form.querySelector('[name="id"]');
      var v = idEl ? vp[idEl.value] : null;
      if (v == null) return s;
      var gTot = info.querySelector('.gpo-total');
      var g = gTot ? cents((gTot.textContent.match(/([\d.,]+)/) || [])[1]) : 0;
      return v + (g || 0);
    }

    function visibleBtn() {
      var btns = Array.prototype.slice.call(form.querySelectorAll('.product-form__submit'));
      return btns.filter(function (b) { return b.offsetParent !== null; })[0] || btns[0];
    }
    function shownPrice() {
      if (!priceEl) return null;
      var cands = Array.prototype.slice.call(priceEl.querySelectorAll('.price__sale .price-item--sale, .price__regular .price-item--regular'));
      var el = cands.filter(function (e) { return e.offsetParent !== null; })[0] || cands[0];
      return el ? cents(el.textContent) : null;
    }
    function render() {
      var btn = visibleBtn();
      if (btn && btn.previousElementSibling !== box) btn.parentNode.insertBefore(box, btn);
      var p = realPrice();
      if (p === null) return;
      var ex = extras(form);
      var exSum = ex.reduce(function (a, x) { return a + x.cents; }, 0);
      var on = ex.length > 0 && exSum < p;
      // DE: karat is the native variant option "Karat" ("14 Karat"); fallbacks: US "Gold Karat", Globo "Gehalt"
      var kEl = info.querySelector('input[name="Goldlegierung"]:checked') || info.querySelector('select[name="Goldlegierung"]') ||
        info.querySelector('select[name="options[Goldlegierung]"]') ||
        info.querySelector('input[name="Karat"]:checked') || info.querySelector('select[name="Karat"]') ||
        info.querySelector('select[name="options[Karat]"]') ||
        info.querySelector('input[name="Gold Karat"]:checked') || info.querySelector('select[name="Gold Karat"]') ||
        info.querySelector('.gpo-element input[name*="gehalt" i]:checked') || info.querySelector('.gpo-element select[name*="gehalt" i]');
      var kv = kEl ? String(kEl.value) : '';
      var km = kv.match(/\b(375|585|750)\b/) || kv.match(/(9|14|18)\s*(Karat|kt|K)\b/i);
      var fine = km ? ({ '9': '375', '14': '585', '18': '750' }[km[1]] || km[1]) : '';
      var name = km ? label + ' ' + fine + ' Gold' : label;
      var html = on
        ? '<div><span>' + name + '</span><span>' + money(p - exSum, cur, locale) + '</span></div>' +
          ex.map(function (x) { return '<div><span>' + x.name + '</span><span>+' + money(x.cents, cur, locale) + '</span></div>'; }).join('') +
          '<div class="is-total"><span>Gesamt</span><span>' + money(p, cur, locale) + '</span></div>'
        : '';
      if (html !== last) { last = html; box.innerHTML = html; }
      if (box.hidden === on) box.hidden = !on;
      info.classList.toggle('mj-ps-on', on);
      // Button always shows the total
      form.querySelectorAll('.product-form__submit').forEach(function (b) {
        var t = b.querySelector('.mj-ps-btn-total');
        if (!t) {
          t = document.createElement('span');
          t.className = 'mj-ps-btn-total';
          var first = b.querySelector('span');
          if (first) first.after(t); else b.appendChild(t);
        }
        var txt = '· ' + money(p, cur, locale);
        if (t.textContent !== txt) t.textContent = txt;
      });
    }
    var queued;
    function schedule() { clearTimeout(queued); queued = setTimeout(render, 60); }
    document.addEventListener('change', schedule); // Globo options and the theme's variant picker (karat)
    form.addEventListener('click', schedule);
    if (window.MutationObserver) {
      if (priceEl) new MutationObserver(schedule).observe(priceEl, { childList: true, subtree: true, characterData: true });
      var wrap = form.querySelector('.product-form__buttons');
      if (wrap) new MutationObserver(function (list) {
        // ignore our own updates
        if (list.every(function (m) { return box.contains(m.target) || (m.target.classList && m.target.classList.contains('mj-ps-btn-total')); })) return;
        schedule();
      }).observe(wrap, { childList: true, subtree: true });
    }
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
